module.exports = __webpack_public_path__ + "static/media/paint.c51eb0ed.svg";